import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Megaphone } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { Toggle } from "../admin/branch/Toggle";
import { myCompany, updateCompany } from "../../api/directory";
import { clearCompanyCache } from "../../api/useMyCompany";

// إعداد الشركة: السماح بإعلان جاهزية الرواتب مبكّراً (الافتراضي لكل الفروع غير المحدّدة).
export const CompanyPayrollPolicy = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState(null);
  const [saved, setSaved] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    myCompany()
      .then((data) => {
        const v = Boolean(data.allow_early_announce);
        setValue(v);
        setSaved(v);
      })
      .catch(() => setValue(null));
  }, []);

  const save = useCallback(async () => {
    setBusy(true);
    try {
      await updateCompany({ allow_early_announce: value });
      clearCompanyCache();
      setSaved(value);
      toast.success(t("company.saved"));
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  }, [value, t]);

  if (value === null) return null;

  return (
    <NeuCard data-testid="company-payroll-policy">
      <p className="label-xs flex items-center gap-2">
        <Megaphone className="h-4 w-4 text-primary" /> {t("branches.companyPayrollTitle")}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">{t("branches.companyPayrollHint")}</p>
      <div className="mt-5">
        <Toggle
          label={t("branches.allowEarlyAnnounce")} testId="company-allow_early_announce"
          value={value} onChange={setValue}
        />
      </div>
      <NeuButton
        variant="primary" className="mt-5" data-testid="company-payroll-save"
        disabled={busy || value === saved} onClick={save}
      >
        {t("app.save")}
      </NeuButton>
    </NeuCard>
  );
};
